<script setup>
import { ref } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  reports: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});
const emit = defineEmits(['generate', 'view']);

const formatDate = d => (d ? new Date(d).toLocaleDateString('pt-BR') : '');

const openId = ref(null);
const select = id => {
  openId.value = id;
  emit('view', id);
};
</script>

<template>
  <div class="rounded-xl border border-n-weak bg-n-background p-4">
    <div class="mb-3 flex items-center justify-between">
      <h3 class="text-sm font-semibold text-n-slate-12">
        Relatórios Estratégicos
      </h3>
      <Button
        variant="solid"
        color="blue"
        size="sm"
        icon="i-lucide-file-plus"
        :is-loading="loading"
        :disabled="disabled"
        @click="emit('generate')"
      >
        Gerar novo
      </Button>
    </div>

    <div v-if="disabled" class="py-4 text-center text-xs text-n-slate-11">
      Selecione um perfil para gerar.
    </div>
    <div
      v-else-if="!reports.length"
      class="py-4 text-center text-xs text-n-slate-11"
    >
      Nenhum relatório ainda.
    </div>

    <div v-else class="space-y-1">
      <button
        v-for="r in reports"
        :key="r.id"
        type="button"
        class="flex w-full items-start justify-between gap-2 rounded-lg border border-n-weak p-2 text-left transition hover:bg-n-slate-2"
        :class="{ 'bg-n-slate-2': openId === r.id }"
        @click="select(r.id)"
      >
        <div class="min-w-0 flex-1">
          <p class="truncate text-xs font-medium text-n-slate-12">
            {{ r.title }}
          </p>
          <p class="text-[10px] text-n-slate-11">
            {{ formatDate(r.createdAt) }}
          </p>
        </div>
        <span class="i-lucide-external-link size-3 shrink-0 text-n-slate-11" />
      </button>
    </div>
  </div>
</template>
